/* Mur d'avis (markup du widget source transporté) : pagination 15/page, tri, dates relatives — données window.ZLR_AVIS */
(function () {
  var root = document.querySelector('[data-zlr-avis]');
  if (!root || !window.ZLR_AVIS || !window.ZLR_AVIS_TPL) return;
  var TPL = window.ZLR_AVIS_TPL, ALL = window.ZLR_AVIS, PER = 15;
  var list = root.querySelector('.tt-review-list'), ctrl = root.querySelector('#reviews-footer .page-control');
  var sort = 'comprehensive-descending', page = 1, rows = ALL.slice();
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function ini(n) {
    var w = n.trim().split(/\s+/).filter(Boolean);
    return (w.length > 1 ? w[0].charAt(0) + w[1].charAt(0) : (w[0] || '').charAt(0)).toUpperCase();
  }
  function rel(d) {
    var t = new Date(d.replace(' ', 'T') + 'Z').getTime(), s = (Date.now() - t) / 1000;
    if (s < 3600) { var m = Math.max(1, Math.round(s / 60)); return 'för ' + m + (m === 1 ? ' minut' : ' minuter') + ' sedan'; }
    if (s < 86400) { var h = Math.floor(s / 3600); return 'för ' + h + (h === 1 ? ' timme' : ' timmar') + ' sedan'; }
    var dd = Math.floor(s / 86400);
    if (dd < 30) return 'för ' + dd + (dd === 1 ? ' dag' : ' dagar') + ' sedan';
    var mo = Math.floor(dd / 30);
    if (mo < 12) return 'för ' + mo + (mo === 1 ? ' månad' : ' månader') + ' sedan';
    var y = Math.floor(dd / 365); return 'för ' + y + ' år sedan';
  }
  function item(r, i) {
    var x = (r[5] ? TPL.verif : TPL.plain);
    var stars = '', k;
    for (k = 0; k < 5; k++) stars += k < r[1] ? TPL.star : TPL.star.replace('class="star-item"', 'class="star-item nostar"');
    x = x.replace(/(<div class="vstar-star">)(?:<div class="star-item">[\s\S]*?<\/div>){5}/, '$1' + stars);
    var res = '';
    if (r[6].length) {
      res = '<div class="resource-list">' + r[6].map(function (p, j) {
        return TPL.res_item.split('[[PHOTO]]').join(p + '?width=220').replace(/index="\d+"/, 'index="' + j + '"').replace(/alt="\d+"/, 'alt="' + j + '"');
      }).join('') + '</div>';
      x = x.replace(/(<p class="reviews-text">\[\[TEXT\]\]<\/p>)/, '$1' + res);
    }
    return x.split('[[DATE]]').join(rel(r[4])).split('[[INI]]').join(esc(ini(r[2]))).split('[[NAME]]').join(esc(r[2]))
      .split('[[TEXT]]').join(esc(r[3])).split('[[STAR]]').join(r[1]).split('[[ID]]').join(r[0])
      .split('[[data-index]]').join(i).split('[[no]]').join(i + 1).split('[[data-page]]').join(page);
  }
  function order() {
    rows = ALL.slice();
    var idx = function (r) { return ALL.indexOf(r); };
    if (sort === 'image-descending') rows.sort(function (a, b) { return (b[6].length > 0) - (a[6].length > 0) || idx(a) - idx(b); });
    if (sort === 'commented-at-descending') rows.sort(function (a, b) { return a[4] < b[4] ? 1 : a[4] > b[4] ? -1 : 0; });
    if (sort === 'rating-descending') rows.sort(function (a, b) { return b[1] - a[1] || idx(a) - idx(b); });
    if (sort === 'rating-ascending') rows.sort(function (a, b) { return a[1] - b[1] || idx(a) - idx(b); });
  }
  function pager() {
    var total = Math.ceil(rows.length / PER), start = Math.max(1, Math.min(page - 2, total - 4)), html = '';
    var pre = ctrl.querySelector('.pre-page'), nxt = ctrl.querySelector('.next-page');
    ctrl.querySelectorAll('.page-control-item').forEach(function (e) { e.remove(); });
    for (var p = start; p <= Math.min(total, start + 4); p++)
      html += '<li class="page-control-item' + (p === page ? ' active' : '') + '" data-index="' + (p - 1) + '" data-number="' + p + '">' + p + '</li>';
    nxt.insertAdjacentHTML('beforebegin', html);
    pre.style.display = page > 1 ? 'flex' : 'none';
    nxt.style.display = page < total ? 'flex' : 'none';
  }
  function render(scroll) {
    var from = (page - 1) * PER;
    list.innerHTML = rows.slice(from, from + PER).map(function (r, i) { return item(r, from + i); }).join('');
    pager();
    if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  ctrl.addEventListener('click', function (e) {
    var it = e.target.closest('.page-control-item, .pre-page, .next-page');
    if (!it) return;
    if (it.classList.contains('pre-page')) page--; else if (it.classList.contains('next-page')) page++; else page = +it.dataset.number;
    render(true);
  });
  var popup = root.querySelector('.sort-popup');
  root.querySelector('.sort-icon').addEventListener('click', function (e) { e.stopPropagation(); popup.style.display = popup.style.display === 'block' ? 'none' : 'block'; });
  document.addEventListener('click', function () { popup.style.display = 'none'; });
  root.querySelectorAll('.sort-item').forEach(function (li, i) {
    li.addEventListener('click', function (e) {
      e.stopPropagation();
      root.querySelectorAll('.sort-item').forEach(function (x) { x.classList.remove('active'); });
      li.classList.add('active');
      root.querySelector('.sort-active').style.top = (54 + 35 * i) + 'px';
      sort = li.getAttribute('sort-value'); page = 1; order(); render(false); popup.style.display = 'none';
    });
  });
  order(); render(false);
})();
